import React from 'react'
import { Button } from '@sainsburys-tech/fable'
import { IphoneX } from '@sainsburys-tech/icons'
import PropTypes from 'prop-types'

export const BuyOnAppButton = ({ link }) => {
  return (
    <Button as='a' isFullWidth icon={<IphoneX />} href={link}>
      Buy on the app
    </Button>
  )
}

BuyOnAppButton.propTypes = {
  link: PropTypes.string.isRequired
}
